// @flow
import * as React from 'react';

import usePermissionMatch from './usePermissionMatch';
import { type Operations } from './types';

type Props = {
    operations: Operations,
    render: (isMatching: boolean) => React.Node
};

const PermissionMatch = ({ operations, render }: Props): React.Node => {
    const isMatching = usePermissionMatch(operations);
    return render(isMatching);
};

export default PermissionMatch;
